import { finish, error } from '../../../modules/customers/actions/adjust';

import api from '../../../api';

export function request(dispatch, { id, amount, method, paymentType, trader, displayedReason }) {
    api.post(
        '/customers/' + id + '/adjust',
        { amount, method, trader, displayedReason, type: paymentType, channel: 'backoffice' }
    ).then(
        (data) => {
            api.get('/customers/' + id).then(
                (customer) => dispatch(finish(id, { customer, transaction: data })),
                () => dispatch(finish(id, { transaction: data }))
            );
        },
        ({ errors }) => dispatch(error(id, errors))
    );
}
